'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value, validationOptions) {
  return value >= validationOptions.min;
}, function (value, validationOptions) {
  return 'Value must be at least ' + validationOptions.min;
}, ['min']);